import bowser from 'yola-bowser';
import MODES from '../constants/modes';

const getPreviewModeForDevice = (deviceMode) => {
  if (deviceMode) return deviceMode;

  if (bowser.mobile) return MODES.mobile;
  if (bowser.tablet) return MODES.tablet;

  return MODES.desktop;
};

export default getPreviewModeForDevice;
